module.exports = __webpack_public_path__ + "assets/d912d2613db408e73dcb66378c2c2231.mp3";